import settingsConfig from 'CampaignBuilder/settingsConfig'
import parse from 'date-fns/parse'

export default function validateSettings(settings, campaignType) {
  const config = settingsConfig[campaignType]
  const validationErrors = []

  const customConfig = _.omitBy(config, (setting, key) => setting.dependsOn && !_.every(setting.dependsOn, (value, key) => _.includes(settings[key], value)))

  _.each(customConfig, (setting, key) => {
    if (setting.required) {
      if (setting.keys) {
        const keys = setting.keys
        keys.forEach((key) => {
          if (!settings[key]) {
            validationErrors.push(`You must set ${setting.label}`)
          }
        })
      } else if (!settings[key]) {
        validationErrors.push(`You must set ${setting.label}`)
      }
    }
    if (setting.validateFn) {
      const errors = setting.validateFn(settings[key], settings)
      if (errors && errors.length > 0) {
        validationErrors.push(...errors)
      }
    }
  })

  if (settings['sendStartTime'] && settings['sendEndTime']) {
    // using date-fns, check the start time is before end time
    const startTime = parse(settings['sendStartTime'], 'HH:mm', new Date())
    const endTime = parse(settings['sendEndTime'], 'HH:mm', new Date())

    if (startTime > endTime) {
      validationErrors.push('Send start time must be before send end time')
    }
  }

  return validationErrors
}
